module.exports = __webpack_public_path__ + "img/logo-orange-yellow-svg.c85af723.svg";